import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const ProfileLayout = styled('div')`
  background-color: ${(props) => props.theme.white};
  padding-left: 13%;
  padding-right: 13%;
  min-width: 50%;
  padding-top: 1px;
  min-height: 85vh;

  .title {
    font-family: ${(props) => props.theme.profileFontFamilySecondary};
    font-size: 42px;
    font-weight: 400;
    line-height: 38px;
    letter-spacing: -0.02em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${(props) => props.theme.profileTitle};
  }

  .sub-title {
    color: ${(props) => props.theme.profileSubTitle};
  }

  .ant-tabs {
    .ant-tabs-tab {
      color: ${(props) => props.theme.grey};

      &.ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: ${(props) => props.theme.black};
        }
      }

      .tab-title {
        font-family: ${(props) => props.theme.profileFontFamilySecondary};
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }
    }

    .ant-tabs-ink-bar {
      background: ${(props) => props.theme.black};
    }
  }

  .log-out {
    font-family: ${(props) => props.theme.profileFontFamilySecondary};
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    text-decoration-line: underline;
    text-decoration-style: solid;
  }

  .ant-tabs-tab-btn {
    font-family: ${(props) => props.theme.profileFontFamilySecondary};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .title {
      font-size: 1.5rem;
    }

    .tab-title {
      font-size: 1rem !important;
    }
  }

  @media (max-width: ${breakpoints.sm}px) {
    padding-left: 6%;
    padding-right: 6%;
  }
`;

export const OrderLayout = styled('div')`
  width: 100%;
  min-height: 25em;

  td {
    font-weight: 400;
    color: ${(props) => props.theme.black};
  }

  .title.sub-title {
    font-family: ${(props) => props.theme.profileFontFamilySecondary};
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    margin-top: 16px;
    margin-bottom: 32px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  .order-actions {
    display: flex;
    justify-content: space-between;
  }

  .order-download {
    margin-left: 15px;
  }

  .view-order,
  .order-download {
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    text-decoration: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${(props) => props.theme.black};
    transition: all 0.1s ease-in-out;
  }

  .ant-pagination {
    padding-top: 50px;
    display: flex !important;
    justify-content: center !important;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      font-family: ${({ theme }) => theme.fontText} !important;
      margin-inline-end: 0 !important;
    }
  }

  .ant-pagination-item-link {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 50% !important;
    transition: background-color 0.3s ease !important;
  }

  .ant-pagination-item-link:hover {
    background-color: ${({ theme }) => theme.lightGrey} !important;
  }

  .ant-pagination-item {
    border: none !important;
    background: transparent !important;
    font-weight: 500 !important;
    color: ${({ theme }) => theme.colorText} !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 32px !important;
    text-align: center !important;
    border-radius: 50% !important;
    transition: all 0.3s ease !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-pagination-item:not(.ant-pagination-item-active):hover {
    background-color: ${({ theme }) => theme.lightGrey} !important;
    color: ${({ theme }) => theme.colorText} !important;
  }

  .ant-pagination-item-active,
  .ant-pagination-item-active:hover {
    background-color: ${({ theme }) => theme.brand01} !important;
    border-color: ${({ theme }) => theme.brand01} !important;
    color: ${({ theme }) => theme.white} !important;
    font-weight: bold !important;
    border-radius: 50% !important;
  }

  .ant-pagination-item-active a,
  .ant-pagination-item-active:hover a {
    color: ${({ theme }) => theme.white} !important;
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    color: ${({ theme }) => theme.colorText} !important;
    width: 40px !important;
    height: 40px !important;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease !important;
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    outline: none !important;
    padding: 0 !important;
  }

  .ant-pagination-prev.ant-pagination-disabled:hover,
  .ant-pagination-next.ant-pagination-disabled:hover {
    background-color: transparent !important;
  }

  .ant-pagination-prev {
    margin-inline-end: 0;
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 16px;
  }

  .ant-pagination-item-link span {
    color: ${({ theme }) => theme.paginationLink};
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .title.sub-title {
      font-size: 1.125rem;
    }

    .ant-table-cell {
      font-size: 1rem;
    }
  }
`;

export const ProfileInfo = styled('div')`
  .title.sub-title {
    font-family: ${(props) => props.theme.profileFontFamilySecondary};
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    margin-top: 16px;
    margin-bottom: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .title.sub-title {
      font-size: 1.125rem;
    }
  }
`;
